export default __webpack_public_path__ + "static/media/Imageone.603bf5f5.JPG";